export default __webpack_public_path__ + "static/media/handshake.cfd89446.svg";